


































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import MaintainRecordDto from '@/store/models/maintain/maintainrecord'
import ReturnVisitRecordDto from '@/store/models/maintain/returnVisitRecord'
@Component({})
export default class ReturnVisit extends VueBase {
	userName: string = ''
	loading: boolean = false
	id: any
	maintainRecord: MaintainRecordDto = new MaintainRecordDto()
	formState: ReturnVisitRecordDto = new ReturnVisitRecordDto()
	showReturnVisitTime: boolean = false
	showSatisfaction: boolean = false
	satisfactions = [5, 4, 3, 2, 1]
	onClickLeft() {
		window.history.go(-1)
	}
	async getById(id: any) {
		await ajax.get('/api/maintainrecord/by-id/' + id)
			.then(rep => {
				Object.assign(this.maintainRecord, rep.data.result)
			})
	}
	onConfirmshowReturnVisitTime(val: any) {
		this.formState.returnVisitTime = util.formatDateTime(val)
		this.showReturnVisitTime = false
	}
	onConfirmSatisfaction(val: any) {
		this.formState.satisfaction = val
		this.showSatisfaction = false
	}
	async onSubmit() {
		this.loading = true
		this.formState.returnVisitBy = this.userName
		this.formState.maintainRecordId = this.id
		this.formState.schoolShortName = this.maintainRecord.schoolShortName
		await ajax.post('/api/maintainrecord/return-visit-record-insert', this.formState)
			.then(() => {
				this.$toast.success('回访成功')
				window.history.back()
			})
			.finally(() => {
				this.loading = false
			})
	}
	async created() {
		this.id = this.$route.query.id
		await this.getById(this.id)
		let user = await this.getCurrentUser()
		this.userName = user.userName
		this.formState.satisfaction = 5
	}
}
